import { render, staticRenderFns } from "./DesktopLeftSidebar.vue?vue&type=template&id=2ba34785&scoped=true"
import script from "./DesktopLeftSidebar.vue?vue&type=script&lang=ts"
export * from "./DesktopLeftSidebar.vue?vue&type=script&lang=ts"
import style0 from "./DesktopLeftSidebar.vue?vue&type=style&index=0&id=2ba34785&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba34785",
  null
  
)

export default component.exports